import React from "react";
import { Upload, Link as LinkIcon, ListChecks, FileCheck } from "lucide-react";

export function HowItWorks({ t }) {
  const steps = [t.how.s1, t.how.s2, t.how.s3, t.how.s4];
  const icons = [Upload, LinkIcon, ListChecks, FileCheck];
  return (
    <section id="how" className="py-12 lg:py-28" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-8 lg:mb-12">
          <div className="overline mb-3">{t.how.sub}</div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-[#292524] leading-tight">
            {t.how.title}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {steps.map((s, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="card card-hover relative" data-testid={`how-step-${i + 1}`}>
                <div className="flex items-center justify-between mb-5">
                  <div className="w-11 h-11 rounded-xl bg-[#FAF6F0] border border-[#EAE5DB] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#D95D39]" />
                  </div>
                  <div className="font-heading font-extrabold text-3xl text-[#EAE5DB]">
                    0{i + 1}
                  </div>
                </div>
                <div className="font-heading font-semibold text-xl text-[#292524] mb-2">
                  {s.t}
                </div>
                <div className="text-[#57534E] text-sm leading-relaxed">{s.d}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
